module.exports = __webpack_public_path__ + "img/zhipinban7.6b29b85f.jpg";